import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { type Nil, Text } from '@pbt/pbt-ui-components'

import { useInventoryItemTrackingItems } from '~/hooks/useInventoryItemTracking'

import ShipmentItemsTable from '../shipments/ShipmentItemsTable'

interface VariationShipmentsSectionProps {
  variationId: string | Nil
}

const VariationShipmentsSection = ({
  variationId,
}: VariationShipmentsSectionProps) => {
  const { t } = useTranslation('Admin')

  const { inventoryItemTrackingItems, isLoading, fetchForVariation } =
    useInventoryItemTrackingItems()

  useEffect(() => {
    if (variationId) {
      // TODO: add pagination when needed
      fetchForVariation(variationId, 0, 100)
    }
  }, [variationId, fetchForVariation])

  return inventoryItemTrackingItems.length > 0 || isLoading ? (
    <ShipmentItemsTable
      deleteDisabled
      duplicateDisabled
      editDisabled
      showDistributor
      isLoading={isLoading}
      shipmentItems={inventoryItemTrackingItems}
    />
  ) : (
    <Text>{t('Admin:CATALOG.VARIATION_SHIPMENTS_SECTION.NO_SHIPMENTS')}</Text>
  )
}

export default VariationShipmentsSection
